import gsap from 'gsap';

export class ProfileAnimations {
  constructor() {
    this.initializePositions();
    this.animateElements();
    this.setupHoverEffects();
    this.setupProfileTiltEffect();
  }

  initializePositions() {
    // Set initial positions for animations
    gsap.set('#profile-name', { y: 20 });
    gsap.set('#profile-desc', { y: 20 });
    gsap.set('#profile-img', { scale: 0.8 });
    gsap.set('#profile-text', { y: 20, opacity: 0 });
    
    const linkButtons = document.querySelectorAll('.links__item');
    linkButtons.forEach(btn => {
      gsap.set(btn, { y: 20, opacity: 0 });
    });
  }

  animateElements() {
    // Profile image animation
    gsap.to('#profile-img', {
      opacity: 1,
      scale: 1,
      duration: 1,
      delay: 0.2,
      ease: 'power3.out'
    });

    // Name animation
    gsap.to('#profile-name', {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay: 0.4,
      ease: 'power3.out'
    });

    // Description animation
    gsap.to('#profile-desc', {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay: 0.6,
      ease: 'power3.out'
    });

    // Link buttons animation
    const linkButtons = document.querySelectorAll('.links__item');
    linkButtons.forEach((btn, index) => {
      gsap.to(btn, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        delay: 0.8 + (index * 0.1),
        ease: 'power3.out'
      });
    });

    // Profile text animation
    gsap.to('#profile-text', {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay: 1.4,
      ease: 'power3.out'
    });
  }

  setupHoverEffects() {
    // Hover handled by CSS transitions
  }

  setupProfileTiltEffect() {
    const profileContainer = document.querySelector('.profile__container');
    
    if (!profileContainer) return;

    let bounds;

    profileContainer.addEventListener('mouseenter', () => {
      bounds = profileContainer.getBoundingClientRect();
    });

    profileContainer.addEventListener('mousemove', (e) => {
      if (!bounds) bounds = profileContainer.getBoundingClientRect();
      
      // Position de la souris par rapport au centre (de -1 à 1)
      const mouseX = (e.clientX - bounds.left) / bounds.width;
      const mouseY = (e.clientY - bounds.top) / bounds.height;
      
      const centerX = mouseX - 0.5;
      const centerY = mouseY - 0.5;
      
      // Rotation plus subtile (max 8 degrés)
      const rotateX = centerY * -15;
      const rotateY = centerX * 15;
      
      // Effet de translation légère pour plus de profondeur
      const translateZ = 10;
      
      gsap.to(profileContainer, {
        rotateX: rotateX,
        rotateY: rotateY,
        z: translateZ,
        duration: 0.6,
        ease: 'power2.out',
        transformPerspective: 1000
      });
    });

    profileContainer.addEventListener('mouseleave', () => {
      gsap.to(profileContainer, {
        rotateX: 0,
        rotateY: 0,
        z: 0,
        duration: 0.8,
        ease: 'elastic.out(1, 0.3)'
      });
    });
  }
}
